<button
  #openCloseButton
  mat-icon-button
  type="button"
  class="notification-center-toggle"
  [attr.aria-label]="bellLabel()"
  [attr.aria-expanded]="open()"
  aria-controls="notification-center-panel"
  (click)="toggleCenter()"
>
  <mat-icon
    [matBadge]="notifications().length"
    [matBadgeHidden]="notifications().length === 0"
    matBadgeColor="accent"
    matBadgeOverlap="true"
    matBadgeSize="small"
    >{{ open() ? "notifications_none" : "notifications" }}</mat-icon
  >
</button>
@if (open()) {
  <section
    id="notification-center-panel"
    class="notification-center-container"
    aria-labelledby="notification-center-heading"
  >
    <header>
      <h2 id="notification-center-heading" i18n="@@notificationCenterTitle">
        Benachrichtigungen
      </h2>
      <div class="header-actions">
        <button
          mat-icon-button
          type="button"
          [attr.aria-label]="settingsLabel"
          [matTooltip]="settingsLabel"
          (click)="openSettings()"
        >
          <mat-icon>settings</mat-icon></button
        ><button
          mat-icon-button
          type="button"
          aria-label="Benachrichtigungen schließen"
          i18n-aria-label="@@notificationCenterClose"
          (click)="close(true)"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </header>
    <p class="subtitle" i18n="@@notificationCenterUnread">
      {{ notifications().length }} ungelesen · letzter Monat
    </p>
    @if (preferences.settings()?.notificationCenterEnabled === false) {
      <div class="paused" role="status">
        <mat-icon aria-hidden="true">notifications_off</mat-icon>
        <div>
          <span i18n="@@notificationCenterPaused"
            >Neue Benachrichtigungen sind deaktiviert. Vorhandene Einträge
            bleiben verfügbar.</span
          ><button
            class="settings-link"
            type="button"
            (click)="openSettings()"
            i18n="@@notificationCenterOpenSettings"
          >
            Einstellungen öffnen
          </button>
        </div>
      </div>
    }
    <div class="notification-list" [attr.aria-busy]="loading()">
      @if (loading() && notifications().length === 0) {
        <div class="center-state">
          <mat-spinner
            diameter="28"
            aria-label="Benachrichtigungen werden geladen"
            i18n-aria-label="@@notificationCenterLoading"
          />
        </div>
      } @else if (failed()) {
        <div class="center-state" role="alert">
          <mat-icon>cloud_off</mat-icon>
          <p i18n="@@notificationCenterLoadError">
            Benachrichtigungen konnten nicht geladen werden.
          </p>
          <button
            class="settings-link"
            type="button"
            (click)="refreshNotifications()"
            i18n="@@notificationTryAgain"
          >
            Erneut versuchen
          </button>
        </div>
      } @else {
        @for (notification of notifications(); track notification.id) {
          <app-notification-item
            [notification]="notification"
            (notificationRead)="onNotificationRead($event)"
          />
        } @empty {
          <div class="center-state">
            <mat-icon class="empty-icon">{{
              preferences.settings()?.notificationCenterEnabled === false
                ? "notifications_off"
                : "check_circle_outline"
            }}</mat-icon>
            <h3 i18n="@@notificationCenterAllRead">Alles gelesen</h3>
            <p i18n="@@notificationCenterEmpty">
              Sie haben alle Benachrichtigungen des letzten Monats gelesen.
            </p>
          </div>
        }
      }
    </div>
  </section>
}
